import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: [],
  isLoading: false,
  isUpdated: false,
};
const getIndex = (state, _value) => {
  return state.findIndex(_state => _state._id == _value);
};
const UserSlice = createSlice({
  name: 'UserSlice',
  initialState,
  reducers: {
    resetUser: (state, action) => {
      state.isLoading = false;
      state.isUpdated = false;
    },
    loadUsers: (state, action) => {
      state.users = action.payload;
    },
    updateUserSuccess: (state, action) => {
      state.users[getIndex(state.users, action.payload._id)] = {
        ...action.payload,
      };
    },
    addUserRequest: (state, action) => {
      state.isLoading = true;
      // state.users.push(action.payload);
    },
    addUserSuccess: (state, action) => {
      state.isUpdated = true;
      state.users.push(action.payload);
    },
    userDeletedSuccess: (state, action) => {
      state.users = state.users.filter(_user => _user._id !== action.payload);
    },
  },
});
export default UserSlice.reducer;
export const {
  loadUsers,
  updateUserSuccess,
  addUserRequest,
  addUserSuccess,
  userDeletedSuccess,
} = UserSlice.actions;
